import {L} from "../../lt-ng/landcare-toolkit";
import {IContextLayerQuery} from "./context-layer-query";
import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import getLayerById = L.tree.getLayerById;
import {Coordinate} from "ol/coordinate";
import {Feature} from "ol";
import GeoJSON from "ol/format/GeoJSON";
import {Geometry} from "ol/geom";

export class KoordinatesLayerQuery implements IContextLayerQuery {
    protected getLayer() {
        return this.layerItem.layerService.koordinatesLayer;
    }

    protected getApiURL(): string {
        return this.getLayer().koordinatesService.serviceUrl;
    };

    constructor(protected layerItem: L.tree.Item,
                protected $http: ng.IHttpService,
                protected mapService: IMapService) {

    }

    get featureName() {
        return this.getLayer().featureName;
    }

    get titleProperty() {
        return this.getLayer().titleProperty;
    }

    queryPointProperties(coordinate: Coordinate, propertyName: string[], cache: boolean = true): ng.IPromise<Array<any>> {
        let layerId = this.getLayer().layerName;
        return this.$http.get(this.getApiURL(), {
            params: {
                layer: layerId,
                x: coordinate[0],
                y: coordinate[1],
                max_results: this.getLayer().radius ? 5 : 1,
                radius: this.getLayer().radius || Math.ceil(this.mapService.map.getView().getResolution()),
                geometry: false,
                with_field_names: true
            },
            cache
        }).then((resp) => {
            const queryLayers = resp.data['vectorQuery']['layers'];
            const fc = queryLayers[layerId] || { features: []};
            return fc.features || [];
        });
    }

    queryPoint(coordinate: Coordinate): angular.IPromise<Array<Feature<Geometry>>> {
        let layerId = this.getLayer().layerName;
        return this.$http.get(this.getApiURL(), {
            params: {
                layer: layerId,
                x: coordinate[0],
                y: coordinate[1],
                max_results: 1,
                radius: Math.ceil(this.mapService.map.getView().getResolution()),
                geometry: true,
                with_field_names: true
            }
        }).then((resp) => {
            let format = new GeoJSON();
            console.log(resp);
            let queryLayers = resp.data['vectorQuery']['layers'];
            let fc = queryLayers[layerId];
            let parsedFeatures = format.readFeatures(fc);
            let sourceLayerId = 0;
            let layerConf = getLayerById(this.mapService.treeData, this.getLayer().layerConfigurationId);
            let titleAttribute : string = this.getLayer() && this.getLayer().titleProperty;
            if (layerConf.length && layerConf[0].layerService) {
                let layerService = layerConf[0].layerService;
                sourceLayerId = layerService.id;
            }
            parsedFeatures.forEach((f: Feature<Geometry>) => {
                let geom = f.getGeometry().transform('EPSG:4326', this.mapService.map.getView().getProjection());
                f.setGeometry(geom);
                if (sourceLayerId) f.set('sourceLayerId', sourceLayerId);
                if (titleAttribute && f.get(titleAttribute)) {
                    f.set('_title', f.get(titleAttribute));
                }
            });
            return parsedFeatures;
        });
    }
}